import {
  AccountInfo,
  AdapterNotDetectedWallet,
  AdapterWallet,
  AptosSignAndSubmitTransactionOutput,
  InputTransactionData,
} from '@aptos-labs/wallet-adapter-core';
import { createContext, useContext } from 'react';

export interface WalletContextState {
  connected: boolean;
  isLoading: boolean;
  account: AccountInfo | null;
  connect(walletName: string): void;
  signAndSubmitTransaction(
    transaction: InputTransactionData,
  ): Promise<AptosSignAndSubmitTransactionOutput>;
  disconnect(): void;
  wallet: AdapterWallet | null;
  wallets: ReadonlyArray<AdapterWallet>;
  notDetectedWallets: ReadonlyArray<AdapterNotDetectedWallet>;
}

const DEFAULT_CONTEXT = {
  connected: false,
};

export const WalletContext = createContext<WalletContextState>(
  DEFAULT_CONTEXT as WalletContextState,
);

export function useWallet(): WalletContextState {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within a WalletContextState');
  }
  return context;
}
